import React, { useState, useEffect } from 'react';
import styled, { ThemeProvider } from 'styled-components';

import GlobalStyle from '../../styles/global';
import AppStyle from '../../styles/app';
import theme from '../../styles/theme';
import SEO from './seo';
import NavMenu from '../nav';
import MobileNav from '../mobile-nav';
import Footer from '../footer';

const StyledPage = styled.div`
	&.blur {
		filter: blur(8px);
	}
`;

const Page = ({ children, title }) => {
	const [isOpen, setOpen] = useState(false);
	const [isBlurred, setBlur] = useState(false);

	// Gives the slide animation a head start to reduce menu lag on first load
	useEffect(() => {
		setTimeout(() => {
			setBlur(isOpen);
		}, 20);
	});

	return (
		<ThemeProvider theme={theme}>
			<AppStyle>
				<GlobalStyle />
				<SEO title={title} />
				<MobileNav setOpen={setOpen} isOpen={isOpen} />
				<StyledPage className={isBlurred ? 'blur' : ''}>
					<NavMenu setOpen={setOpen} isOpen={isOpen} />
					{children}
					<Footer />
				</StyledPage>
			</AppStyle>
		</ThemeProvider>
	);
};

export default Page;
